import { useMemo } from "react"

export enum DeviceType {
  iOS = "iOS",
  Android = "Android",
  Desktop = "Desktop",
}

export function useDeviceType(): DeviceType {
  return useMemo(() => {
    const ua = navigator.userAgent

    // Covers iPhones, iPads (including iPadOS 13+ in desktop mode)
    const isIOS =
      /iPhone|iPad|iPod/.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)

    if (isIOS) return DeviceType.iOS
    if (/Android/i.test(ua)) return DeviceType.Android

    return DeviceType.Desktop
  }, [])
}
